import * as yup from 'yup';
import { error } from '../text';
import type { ContactFormData } from '../../types/contact';

export const contactSchema: yup.ObjectSchema<ContactFormData> = yup.object().shape({
  companyName: yup.string().required(error.required),
  // 担当者登録・企業招待と揃えて部署名は任意入力とする（#3071）
  department: yup.string().max(250, error.below250).default(''),
  name: yup.string().required(error.required),
  email: yup.string().email(error.email).required(error.required),
  phoneNumber: yup
    .string()
    .required(error.required)
    .matches(/^[0-9-]*$/, error.tel)
    .max(20, error.below20),
  category: yup
    .number()
    .oneOf([1, 2, 3, 99], error.required)
    .required(error.required) as yup.Schema<1 | 2 | 3 | 99>,
  message: yup.string().required(error.required).max(2000, error.below2000),
}) as yup.ObjectSchema<ContactFormData>;
